<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;
</script>

<OffsetThresholdWrapperGBLE {device} setting="threshold" type="bright" min={0} max={65535} />
